<template>
  <div id="app">
    <router-link to="/" tag="h1">BHARGAV MODHA</router-link>
    <div id="nav">
      <router-link to="/" tag="button" exact>Bhargav_Modha</router-link>
      <router-link to="/activities" tag="button">ACTIVITIES</router-link>
      <router-link to="/projects" tag="button">PROJECTS</router-link>
      <router-link to="/education" tag="button">EDUCATION</router-link>
    </div>

    <div class="container">
      <div class = "container_cat">
      <transition name="anim1" mode="out-in">
        <h2 :key="path" v-if="path!=null">{{ path.toUpperCase() }}</h2>
      </transition>
      </div>
      <div class = "container_item">
      <transition name="stroke" mode="out-in">
        <h2 :key="sharedState.state.Sub_Path" class="stroke">{{ sharedState.getSubPath() }}</h2>
      </transition>
      </div>
    </div>

    <router-view/>
    <div id="Grain"></div>

    <svg width="0" height="0">
  <filter id="kill">
    <feColorMatrix type="matrix" 
      result="red_"             
      values="4 0 0 0 0
              0 0 0 0 0 
              0 0 0 0 0 
              0 0 0 1 0"/>
    <feOffset in="red_" dx="1" dy="2" result="red"/>
    <feColorMatrix type="matrix" 
      in="SourceGraphic"             
      result="blue_"             
      values="0 0 0 0 0
              0 3 0 0 0 
              0 0 10 0 0 
              0 0 0 1 0"/>
    <feOffset in="blue_" dx="-1" dy="-2" result="blue"/>    
    <feBlend mode="screen" in="red" in2="blue"/>
  </filter>
</svg>

  </div>
</template>

<script>

import axios from "axios";
import {store} from "./store.js";

export default {
  data() {
    return {
      path: null,
      sharedState : store
    };
  },
  methods: {
    getPath: function() {
      if(this.$router.history.current.name=="categories" || this.$router.history.current.name=="unique"){
        this.path = this.$router.currentRoute.path.split("/")[1];
      }
      else{
        this.path = this.$router.history.current.name;
      }
    },
    getFav(){
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          this.changeFav("./favicon.ico");
          }
        else{
          this.changeFav("./favicon_Dark.ico");
        }
    },
    changeFav(src){
      var link = document.createElement('link'),
      oldLink = document.getElementById('dynamic-favicon');
      link.id = 'dynamic-favicon';
      link.rel = 'shortcut icon';
      link.href = src;
      if (oldLink) {
        document.head.removeChild(oldLink);
      }
      document.head.appendChild(link);
    }
  },created() {
    this.getPath();
    // DIDNT WORK
    // this.getFav();
    },
  watch: {
    $route(to, from) {
      this.getPath();
    }
}
}
</script>

<style>

*{
  color:white;
}

body{
  min-width: 500px;
  background-color: black;
}

#Grain{
  position:fixed;
  pointer-events:none;
  -webkit-animation:grainAnimation 1.2s infinite;
  animation:grainAnimation 1.2s infinite;
  background-image:url(../src/assets/New_Noise_2.png); 
  opacity:0.99;
  height:180%;
  left:-40%;
  top:-40%;
  width:180%;
  z-index:-1;
}

#app {
  font-family: "Helvetica";  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 50em;
  margin: auto;
  overflow: hidden;
}



h1{
  -webkit-text-stroke: 0.5px white;
  font-size: 3.7em;
  color:transparent;
  text-align: center;
  -webkit-margin-before: 0.3em;
          margin-block-start: 0.3em;
  -webkit-margin-after: 0.4em;
          margin-block-end: 0.4em;
  -webkit-transition:0.4s ease;
  -o-transition:0.4s ease;
  transition:0.4s ease;
}

h1:hover{
  -webkit-text-stroke: 0.5px transparent;
  color:white;
}

#nav{
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr 0.2em 1fr 0.2em 1fr 0.2em 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 0.2em;
  text-align: center;
}

#nav button{
  font-family: "Courier";
  padding:0.2em 2em ;
}


button{
  background-color: transparent;
  border: none;
  text-decoration: none;  
}

button:hover{
  background-color: white;
  color:black;
}
button:focus {
  outline:0;
}

/* #nav button:hover, */
#nav button.router-link-active
/* #nav button.router-link-exact-active */
{
  background-color: rgb(179, 179, 179);
  color:black;

  /* background-color: transparent;
  color: white; */

  /* text-decoration: line-through; */
  /* border-bottom: 0.2px dashed white; */

  -webkit-filter: url(#kill);
          filter: url(#kill);
}

#nav button:hover,
#nav button.router-link-active:hover{
  background-color:white ;
  color: black;

  /* background-color: transparent;
  color: white; */

  -webkit-filter: none;
          filter: none;
}

ul{
  list-style-type: none;
}

.stroke{
  color:transparent;
  -webkit-text-stroke: 0.4px white;
}

.container {
  overflow: hidden;
  margin-top:3em;
  -ms-grid-columns: 1.25fr 4fr;
  grid-template-columns: 1.25fr 4fr;
}


.container_cat h2{
  font-size: 2.3em;
  padding: none;
  padding-right:0.2em;
  -webkit-margin-before: 0em;
          margin-block-start: 0em;
  -webkit-margin-after: 0em;
          margin-block-end: 0em;
}

.container_item h2{
  font-size: 1.6em;
  padding: none;
  padding-right:0.2em;
  -webkit-margin-before: 0em;
          margin-block-start: 0em;
  -webkit-margin-after: 0em;
          margin-block-end: 0em;
}

.container_cat{
  -ms-grid-column: 1;
  grid-column: 1;
  overflow: hidden;
}

.container_item{
  -ms-grid-column: 2;
  grid-column: 2;
  overflow: hidden;
}


.anim1-enter-active,.anim1-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.anim1-leave-to{ 
  -webkit-transform: translateY(5em); 
      -ms-transform: translateY(5em); 
          transform: translateY(5em);
}
.anim1-enter{
  -webkit-transform: translateY(-5em);
      -ms-transform: translateY(-5em);
          transform: translateY(-5em);
}


.stroke-enter-active,.stroke-leave-active {
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.stroke-leave-to{ 
  -webkit-transform: translateY(-5em); 
      -ms-transform: translateY(-5em); 
          transform: translateY(-5em);
}
.stroke-enter{
  -webkit-transform: translateY(-5em);
      -ms-transform: translateY(-5em);
          transform: translateY(-5em);
}


  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: black;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(126, 126, 126);
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: white;
  }


@media only screen and (max-width: 850px) {
  h1{
    font-size: 3em;
  }

  #nav{
    text-align: center;
    margin :0 auto;
    max-width: 80%;
    -ms-grid-columns: 1fr;
    grid-template-columns: 1fr;
  }

  #app{
    padding: 1em;
  }

  /* #nav button.router-link-active{
    background-color: white;
    filter: none;
  } */

}



@-webkit-keyframes grainAnimation
{
  0%{-webkit-transform:translate(0,0);transform:translate(0,0)}
  10%{-webkit-transform:translate(-5%,-5%);transform:translate(-5%,-5%)}
  20%{-webkit-transform:translate(-10%,5%);transform:translate(-10%,5%)}
  30%{-webkit-transform:translate(5%,-10%);transform:translate(5%,-10%)}
  40%{-webkit-transform:translate(-5%,15%);transform:translate(-5%,15%)}
  50%{-webkit-transform:translate(-10%,5%);transform:translate(-10%,5%)}
  60%{-webkit-transform:translate(15%,0);transform:translate(15%,0)}
  70%{-webkit-transform:translate(0,10%);transform:translate(0,10%)}
  80%{-webkit-transform:translate(-15%,0);transform:translate(-15%,0)}
  90%{-webkit-transform:translate(10%,5%);transform:translate(10%,5%)}
  100%{-webkit-transform:translate(5%,0);transform:translate(5%,0)}
}
@keyframes grainAnimation
{
  0%{-webkit-transform:translate(0,0);transform:translate(0,0)}
  10%{-webkit-transform:translate(-5%,-5%);transform:translate(-5%,-5%)}
  20%{-webkit-transform:translate(-10%,5%);transform:translate(-10%,5%)}
  30%{-webkit-transform:translate(5%,-10%);transform:translate(5%,-10%)}
  40%{-webkit-transform:translate(-5%,15%);transform:translate(-5%,15%)}
  50%{-webkit-transform:translate(-10%,5%);transform:translate(-10%,5%)}
  60%{-webkit-transform:translate(15%,0);transform:translate(15%,0)}
  70%{-webkit-transform:translate(0,10%);transform:translate(0,10%)}
  80%{-webkit-transform:translate(-15%,0);transform:translate(-15%,0)}
  90%{-webkit-transform:translate(10%,5%);transform:translate(10%,5%)}
  100%{-webkit-transform:translate(5%,0);transform:translate(5%,0)}
}
</style>